import * as types from '../actions/types';

const initialState = {
  user: {},
  token: null,
  site_name: '', 
  error: false,
  accessTime: null
};

const loginReducer = function (state = initialState, action) {
  switch (action.type) {
  case types.LOGIN_SUCCESS:
    return {
      ...state,
      user: action.user,
      token: action.token,
      site_name: action.site_name,
      error: action.error,
      accessTime: action.accessTime
    };
  case types.LOGIN_ERROR:
    return Object.assign({}, state, {
      user: {},
      token: null,
      site_name: '',
      error: true
    });
  case types.LOGOUT_SUCCESS:
    return {
      ...state,
      user: {},
      token: null,
      site_name: '',
    };
  case types.TOKEN_REFRESH_SUCCESS:
    return {
      ...state,
      token: action.token,
      accessTime: action.accessTime,
    };
  default:
    return state;
  }
};

export default loginReducer;
